import { Component, CUSTOM_ELEMENTS_SCHEMA, signal } from "@angular/core";
import { SidebarComponent } from "./common/sidebar/sidebar.component";
import { CommonModule, NgClass, ViewportScroller } from "@angular/common";
import { Router, NavigationEnd, RouterOutlet } from "@angular/router";
import { ToggleService } from "./common/sidebar/toggle.service";
import { CustomizerSettingsService } from "src/app/core/services/customizer-settings.service";
import { HeaderComponent } from "./common/header/header.component";
import { FooterComponent } from "./common/footer/footer.component";
import { AuthService } from "../core/services/auth.service";

@Component({
  selector: "app-department-dashboard",
  standalone: true,
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  imports: [
    RouterOutlet,
    CommonModule,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    NgClass,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DepartmentDashboardComponent {
  loggedInUser = localStorage.getItem("loggedInUser")
    ? JSON.parse(localStorage.getItem("loggedInUser")!)
    : null;
  protected readonly title = signal(
    "Cultural Troupe Management System",
  );

  // isSidebarToggled
  isSidebarToggled = false;

  private previousUrl: string | null = null;

  constructor(
    public router: Router,
    private toggleService: ToggleService,
    private viewportScroller: ViewportScroller,
    public themeService: CustomizerSettingsService,
    private authService: AuthService,
  ) {
    const isLoggedIn = this.authService.isLoggedIn();
    if (!isLoggedIn) {
      this.router.navigate(["/login"]);
    } else {
      const user = JSON.parse(localStorage.getItem("loggedInUser")!);
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          const currentUrl = event?.urlAfterRedirects;
          // Scroll to top ONLY if navigating to a different route (not on refresh)
          if (this.previousUrl && this.previousUrl !== currentUrl) {
            this.viewportScroller.scrollToPosition([0, 0]);
          }
          this.previousUrl = currentUrl;
        }
      });
      this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
        this.isSidebarToggled = isSidebarToggled;
      });
    }
  }
}
